






























































































































import { Vue, Provide, Component } from "vue-property-decorator";
import errorsUtil from "./../utils/errorMappings";
import _ from "lodash";

@Component({
  components: {},
})
export default class SupportSwitchAccount extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;

  private accountList = [];
  private loading = false;
  private errorMessage = "";
  private searchTerm = "";
  private isSearchClickedAtleastOnce = false;
  private selectedAccountId = "";
  private caseNumber = "";
  private isLaunchingAccount = false;

  onSearchSubmit(event) {
    if (this.searchTerm.trim().length === 0) {
      this.searchTerm = "";
      return;
    }
    this.onSearchClicked(event);
  }

  async onSearchClicked(event) {
    this.isLaunchingAccount = false;
    this.isSearchClickedAtleastOnce = true;
    this.searchTerm = this.searchTerm.trim();
    this.accountList = [];
    this.loading = true;
    this.$store.commit("startLoading");
    try {
      const accountListResponse = await this.$api.get(
        `api/support/accountsearch?term=${this.searchTerm}`
      );
      this.accountList = accountListResponse.data.value;
      this.$store.commit("stopLoading");
      this.loading = false;
    } catch (error) {
      this.$store.commit("stopLoading");
      this.loading = false;
      const errorCode = error.response.data.code;
      if (_.has(errorsUtil.errorMessages, errorCode)) {
        this.$store.commit("recordError", "");
        this.errorMessage = errorsUtil.errorMessages[errorCode];
      }
      this.$store.commit("stopLoading");
      this.loading = false;
    }
  }

  onAccountLaunchClicked(event, accountId) {
    this.selectedAccountId = accountId;
    this.openCaseNumberDialog();
  }

  openCaseNumberDialog() {
    (this.$refs["case-number"] as any).showModal();
  }

  onCloseCaseNumberDialog() {
    this.selectedAccountId = "";
    this.caseNumber = "";
    (this.$refs["case-number"] as any).close();
  }

  async onSaveCaseNumberDialog() {
    (this.$refs["case-number"] as any).close();
    try {
      this.caseNumber = this.caseNumber.trim();
      this.loading = true;
      this.$store.commit("startLoading");
      await this.$api.get(
        `api/support/accountoverride/${this.selectedAccountId}/${this.caseNumber}`
      );
      this.$store.commit("stopLoading");
      this.isLaunchingAccount = true;
      this.loading = false;
      window.location.href = "/";
    } catch (error) {
      this.$store.commit("stopLoading");
      this.loading = false;
      const errorCode = error.response.data.code;
      if (_.has(errorsUtil.errorMessages, errorCode)) {
        this.$store.commit("recordError", "");
        this.errorMessage = errorsUtil.errorMessages[errorCode];
      }
    }
  }
}
